import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "./api";

function ChangePassword() {
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isChanging, setIsChanging] = useState(false);

  const address = params.get("address");
  const key = params.get("key")

  useEffect(() => {
    async function checkEmailVerificationExists() {
      if(!(await api.GET(`/v2/user/checkGroupPasswordChangeEmailExists?address=${address}&key=${key}`, { "API-Key": "Exosystems170104" })).response) {
        alert("유효하지 않은 요청입니다.");
        window.close();
      }
      else {
        setIsLoading(false);
      }
    }
    checkEmailVerificationExists();
  }, []);

  async function changePassword() {
    setIsChanging(true);
    try {
      await api.POST("/v2/user/changeGroupPassword", { address, key, password }, { "API-Key": "Exosystems170104" });
      alert("비밀번호 변경을 완료했습니다.");
      window.close();
    } catch (error) {
      alert("비밀번호 변경 중 오류가 발생했습니다. 관리자에게 문의하시기 바랍니다.");
    }
    setIsChanging(false);
  }
  
  function checkPassword() {
    return password === confirmPassword && validatePassword();
  }

  function validatePassword() {
    const r1 = /^[!-~]*$/;
    if(password.length < 10 || !r1.test(password)) {
      return false;
    }

    const r2 = [/.*[a-z].*/, /.*[A-Z].*/, /.*[0-9].*/, /.*[!-/:-@\[-`{-~].*/];
    const matchList = r2.map((v) => v.test(password));
    return matchList.filter((v) => v).length >= 2;
  }

  if(isLoading) {
    return (
      <div/>
    );
  }

  return (
    <div>
      <div style={{ position: "relative", width: 265, padding: 15, border: "1px solid black" }}>
        <div style={{ position: "absolute", top: -15, backgroundColor: "white", padding: 5 }}>
          비밀번호 규칙
        </div>
        <div>1. 10자 이상</div>
        <div>2. 영문 소문자, 대문자, 숫자, 특수문자 중 2가지 이상 포함</div>
      </div>
      <div style={{ display: "flex", marginTop: 10 }}>
        <div style={{ width: 120 }}>비밀번호</div>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}/>
      </div>
      <div style={{ display: "flex", marginTop: 10 }}>
        <div style={{ width: 120 }}>비밀번호 확인</div>
        <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}/>
      </div>
      <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
        <button disabled={isChanging || !checkPassword()} onClick={changePassword}>비밀번호 변경</button>
      </div>
    </div>
  );
}

function ChangePasswordContainer() {
  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
      <ChangePassword/>
    </div>
  );
}

export default ChangePasswordContainer;